(() => {
  const sections = document.querySelectorAll('.sas-video-cards');
  if (!sections.length) return;

  const setupPreview = (video) => {
    if (video.dataset.previewSetup === 'true') return;
    video.dataset.previewSetup = 'true';
    const maxSeconds = Number(video.dataset.previewMax) || 7;

    const loopPreview = () => {
      if (video.currentTime >= maxSeconds) {
        video.currentTime = 0;
      }
    };

    video.addEventListener('timeupdate', loopPreview);
  };

  const openModal = (section, type, src) => {
    if (!src) return;
    const modal = section.querySelector('[data-video-modal]');
    const media = modal.querySelector('[data-modal-media]');
    media.innerHTML = '';

    if (type === 'mp4') {
      const video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      media.appendChild(video);
    } else if (type === 'youtube' || type === 'vimeo') {
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; fullscreen; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = 'Video';
      media.appendChild(iframe);
    }

    modal.hidden = false;
    document.body.classList.add('sas-video-cards--modal-open');
  };

  const closeModal = (section) => {
    const modal = section.querySelector('[data-video-modal]');
    const media = modal.querySelector('[data-modal-media]');
    media.innerHTML = '';
    modal.hidden = true;
    document.body.classList.remove('sas-video-cards--modal-open');
  };

  sections.forEach((section) => {
    const previewVideos = section.querySelectorAll('video[data-preview="true"]');
    previewVideos.forEach(setupPreview);

    const cards = section.querySelectorAll('.sas-video-cards__card[data-has-video="true"]');
    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-video-trigger]');
        if (trigger) {
          event.preventDefault();
        }
        openModal(section, card.dataset.videoType, card.dataset.videoSrc);
      });
    });

    const modal = section.querySelector('[data-video-modal]');
    modal.addEventListener('click', (event) => {
      if (event.target.matches('[data-modal-close]')) {
        closeModal(section);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal(section);
      }
    });
  });
})();
